import types from "../types";
import LOGO_BUSINESS from "../assets/img/favicon.ico";
import { CHAT_BOT_USER_ID, NAME_BUSINESS } from "../utils/constants";
import {
  CHAT_FIRST_MESSAGE_BOT,
  NAME_BUSINESS_BOT,
} from "../locales/keysTranslations";
import i18next from "i18next";

const initialState = {
  isOpen: false,
  chats: {},
  chatsMessages: {},
  currentChat: {},
  currentChatMessages: {},
  isUploadingFile: false,
  currentWriteMessage: "",
  isTypingBot: false,
};

export const chatReducer = (state = initialState, action) => {
  let chats = "";
  let chat = "";
  let chatID = "";
  let messages = "";
  let messageID = "";
  let newMessage = "";
  let data = "";
  switch (action.type) {
    case types.OPEN_CHAT:
      return {
        ...state,
        isOpen: true,
      };
    case types.CLOSE_CHAT:
      return {
        ...state,
        isOpen: false,
      };
    case types.SET_CHAT_BOT_DEFAULT:
      return {
        ...state,
        currentChat: initialState.currentChat,
      };
    case types.SET_CURRENT_WRITE_MESSAGE:
      return {
        ...state,
        currentWriteMessage: action.payload,
      };
    case types.SET_CHATS:
      return {
        ...state,
        chats: {
          [CHAT_BOT_USER_ID]: {
            userID: CHAT_BOT_USER_ID,
            chatID: CHAT_BOT_USER_ID,
            name: i18next.t(NAME_BUSINESS_BOT, {
              NAME_BUSINESS,
            }),
            lastMessage: i18next.t(CHAT_FIRST_MESSAGE_BOT),
            lastSender: CHAT_BOT_USER_ID,
            imageURL: LOGO_BUSINESS,
          },
          ...state.chats,
          ...(action.payload || {}),
        },
      };
    case types.SET_CHATS_MESSAGES:
      return {
        ...state,
        chatMessages: action.payload || {},
      };

    case types.SET_CURRENT_CHAT_MESSAGES:
      return {
        ...state,
        chatsMessages: {
          ...state.chatsMessages,
          [action.payload.chatID]: action.payload.messages,
        },
        currentChatMessages: action.payload.messages,
      };
    case types.SET_CURRENT_CHAT:
      return {
        ...state,
        currentChat: action.payload,
        currentChatMessages: state.chatsMessages[action?.payload?.chatID] || {},
        currentWriteMessage: "",
      };
    case types.SET_IS_TYPING_BOT:
      return {
        ...state,
        isTypingBot: !state.isTypingBot,
      };
    case types.ADD_MESSAGE_CHAT:
      newMessage = action.payload.message;
      chatID = action.payload.chatID;
      messageID = action.payload.messageID;
      chats = state.chats || {};
      return {
        ...state,
        currentChatMessages: action.payload.addToCurrentChat
          ? {
              ...state.currentChatMessages,
              [messageID]: newMessage,
            }
          : {
              ...state.currentChatMessages,
            },
        chatsMessages: {
          ...state.chatsMessages,
          [chatID]: { ...state.chatsMessages[chatID], [messageID]: newMessage },
        },
        currentChat: {
          ...state.currentChat,
          lastMessage: newMessage.message,
          lastSender: newMessage.userID,
        },
        chats: {
          ...state.chats,
          [chatID]: {
            ...chats[chatID],
            lastMessage: newMessage.message,
            lastSender: newMessage.userID,
          },
        },
      };
    case types.ADD_MESSAGES_CHAT:
      newMessage = action.payload.message;
      chatID = action.payload.chatID;
      messageID = action.payload.messageID;
      chats = state.chats || {};

      return {
        ...state,
        chatsMessages: {
          ...state.chatsMessages,
          [chatID]: { ...state.chatsMessages[chatID], [messageID]: newMessage },
        },
        chats: {
          ...state.chats,
          [chatID]: {
            ...chats[chatID],
            lastMessage: newMessage.message,
            lastSender: newMessage.userID,
          },
        },
      };
    case types.ADD_MESSAGE_CHAT_IN_LIST:
      newMessage = action.payload.message;
      chatID = action.payload.chatID;
      messages = state.chatsMessages[chatID] || {};
      messageID = action.payload.messageID;

      return {
        ...state,
        chatsMessages: {
          ...state.chatsMessages,
          [chatID]: { ...messages, [messageID]: newMessage },
        },
        chats: {
          ...state.chats,
          [chatID]: {
            ...chats[chatID],
            lastMessage: newMessage.message,
            lastSender: newMessage.userID,
          },
        },
      };
    case types.OPEN_AMBASSADOR_CONVERSATION:
      data = action.payload;

      return {
        ...state,
        chats: { ...state.chats, [data.chatID]: data },
        currentChatMessages: state.chatsMessages[data.chatID] || {},
      };

    case types.OPEN_PUBLICATION_NEW_CONVERSATION:
      return {
        ...state,
        chats: { ...state.chats, [data.chatID]: data },
        currentChatMessages: state.chatsMessages[data.chatID] || {},
      };

    case types.SET_NEW_CHAT:
      chatID = action.payload.chatID;
      chat = action.payload.chat;
      return {
        ...state,
        chats: { ...state.chats, [chatID]: chat },
        currentChat: chat,
      };

    case types.MARK_READ_CHAT:
      chatID = action.payload;
      return {
        ...state,
        chats: {
          ...state.chats,
          [chatID]: { ...state.chats[chatID], isRead: true },
        },
      };
    case types.MARK_DISABLED_CHAT:
      chatID = action.payload;
      return {
        ...state,
        chats: {
          ...state.chats,
          [chatID]: { ...state.chats[chatID], isDisabled: true },
        },
        currentChat: {
          ...state.currentChat,
          isDisabled: true,
        },
      };

    case types.CLEAR_TEMPORARY_CHATS:
      chats = state.chats || {};
      const chatsFiltered = {};
      Object.keys(chats).forEach((chatID) => {
        if (chats[chatID].isTemporary) return false;
        return (chatsFiltered[chatID] = chats[chatID]);
      });
      return {
        ...state,
        chats: chatsFiltered,
        currentChat: state.chats[CHAT_BOT_USER_ID],
        currentChatMessages: state.chatsMessages[CHAT_BOT_USER_ID] || {},
      };

    case types.SET_UPLOADING_FILE:
      return {
        ...state,
        isUploadingFile: !state.isUploadingFile,
      };

    case types.GLOBAL_RESET_STATE:
      return initialState;
    case types.GLOBAL_RESET_DATA_SHOP:
      return initialState;

    default:
      return state;
  }
};
